import { AiseaApiFactory } from "@/api/aisea/apiFactory";
import C from "../../Constants";

// 船舶マスターリポジトリ
const enterpriseManningVesselsRepository = AiseaApiFactory.get(
  "enterpriseManningVessels"
);

/**
 * 船舶マスターサービス
 */
const EnterpriseManningVesselsService = (() => {
  let _enterpriseManningVessels = null;

  const fetch = async () => {
    const payload = {
      details: ["MANNING_VESSEL_ROLE_POSITION", "MANNING_VESSEL_ROLE"],
    };
    const res = await enterpriseManningVesselsRepository.fetch(payload);
    if (!res || !res.status) {
      throw res;
    }
    _enterpriseManningVessels = res.data;
    return _enterpriseManningVessels;
  };

  const clear = () => {
    _enterpriseManningVessels = null;
  };

  const findById = id => {
    if (!_enterpriseManningVessels) {
      return null;
    }

    return (
      _enterpriseManningVessels.manning_vessels.find(
        vessel => vessel.id === id
      ) || null
    );
  };

  /**
   * 役職ポジションを船舶ID、役職ID、役職ポジションIDで検索する
   * @param {string} vesselId
   * @param {string} roleId
   * @param {string} rolePositionId
   * @returns
   */
  const findRolePositionByIds = (vesselId, roleId, rolePositionId) => {
    if (!_enterpriseManningVessels) {
      return null;
    }

    const vessel = _enterpriseManningVessels.manning_vessels.find(
      vessel => vessel.id === vesselId
    );
    if (!vessel) {
      return null;
    }

    const role = vessel.manning_vessel_roles.find(
      role => role.enterprise_crew_role_id === roleId
    );
    if (!role) {
      return null;
    }

    const rolePosition = role.manning_vessel_role_positions.find(
      position => position.id === rolePositionId
    );
    if (!rolePosition) {
      return null;
    }

    return rolePosition;
  };

  /**
   * 船舶の航行区域名を取得する
   * @param {Object} vessel - 船舶オブジェクト
   */
  const getNavigationAreaName = vessel => {
    if (!vessel || !vessel.navigation_area) {
      return "";
    }
    let navigationAreaName =
      C.VESSEL_NAVIGATION_AREA_NAME[vessel.navigation_area];
    if (!navigationAreaName) {
      // 航行区域名が定義されていない場合は空文字を返す
      navigationAreaName = "";
    }
    return navigationAreaName;
  };

  /**
   * 船舶の航行時間名を取得する
   * @param {Object} vessel - 船舶オブジェクト
   * @returns {string} 航行時間名
   */
  const getNavigationTimeName = vessel => {
    if (!vessel || !vessel.navigation_time) {
      return "";
    }

    let navigationTimeName =
      C.VESSEL_NAVIGATION_TIME_NAME[vessel.navigation_time];
    if (!navigationTimeName) {
      // 航行時間名が定義されていない場合は空文字を返す
      navigationTimeName = "";
    }
    return navigationTimeName;
  };

  return {
    fetch,
    clear,
    findById,
    findRolePositionByIds,
    getNavigationAreaName,
    getNavigationTimeName,
  };
})();

export default EnterpriseManningVesselsService;
